import { render, staticRenderFns } from "./MultipleChoiceSlide.vue?vue&type=template&id=5a4b7cf6&scoped=true&"
import script from "./MultipleChoiceSlide.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b7cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4b7cf6')) {
      api.createRecord('5a4b7cf6', component.options)
    } else {
      api.reload('5a4b7cf6', component.options)
    }
    module.hot.accept("./MultipleChoiceSlide.vue?vue&type=template&id=5a4b7cf6&scoped=true&", function () {
      api.rerender('5a4b7cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/components/slides/MultipleChoiceSlide.vue"
export default component.exports